(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[101],{

/***/ 92821:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "GT": function() { return /* binding */ IsEnum; }
/* harmony export */ });
/* unused harmony exports IS_ENUM, isEnum */
/* harmony import */ var _common_ValidateBy__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(42521);

var IS_ENUM = 'isEnum';
/**
 * Checks if a given value is an enum
 */
function isEnum(value, entity) {
    var enumValues = Object.keys(entity).map(function (k) { return entity[k]; });
    return enumValues.indexOf(value) >= 0;
}
/**
 * Checks if a given value is an enum
 */
function IsEnum(entity, validationOptions) {
    return (0,_common_ValidateBy__WEBPACK_IMPORTED_MODULE_0__/* .ValidateBy */ .Y)({
        name: IS_ENUM,
        constraints: [entity],
        validator: {
            validate: function (value, args) { return isEnum(value, args.constraints[0]); },
            defaultMessage: (0,_common_ValidateBy__WEBPACK_IMPORTED_MODULE_0__/* .buildMessage */ .l)(function (eachPrefix) { return eachPrefix + '$property must be a valid enum value'; }, validationOptions),
        },
    }, validationOptions);
}
//# sourceMappingURL=IsEnum.js.map

/***/ }),

/***/ 44772:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/park-safe/faq",
      function () {
        return __webpack_require__(110);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 80452:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "F": function() { return /* binding */ useParkSafe; }
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/@tanstack+react-query@4.2.1_biqbaboplfbrettd7655fr4n2y/node_modules/@tanstack/react-query/build/umd/index.production.js
var index_production = __webpack_require__(15265);
// EXTERNAL MODULE: ../next-utils/src/lib/HttpClient.ts
var HttpClient = __webpack_require__(74552);
;// CONCATENATED MODULE: ./modules/Api/ParkSafe/ParkSafeApi.ts

class ParkSafeApi {
    async approveParkSafe(data) {
        return this.client.put("/api/park-safe/approval", data);
    }
    async getParkSafe(slug) {
        return this.client.get("/api/park-safe/".concat(slug));
    }
    constructor(client = new HttpClient/* HttpClient */.e()){
        this.client = client;
    }
}

;// CONCATENATED MODULE: ./modules/ParkSafe/hooks.ts


const useParkSafe = ()=>{
    const parkSafeApi = new ParkSafeApi();
    const useParkSafeQuery = (slug)=>(0,index_production.useQuery)([
            "park-safe",
            slug
        ], ()=>parkSafeApi.getParkSafe(slug), {
            refetchOnWindowFocus: false
        });
    const useUpdateParkSafe = function() {
        let { onSuccess , onError  } = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        return (0,index_production.useMutation)((data)=>parkSafeApi.approveParkSafe(data), {
            onSuccess,
            onError
        });
    };
    return {
        useUpdateParkSafe,
        useParkSafeQuery
    };
};


/***/ }),

/***/ 4245:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "_": function() { return /* binding */ QuillWrapper; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97458);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52983);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(83849);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);



const QuillWrapper = (param)=>{
    let { htmlContent , className  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: classnames__WEBPACK_IMPORTED_MODULE_2___default()(className),
        dangerouslySetInnerHTML: {
            __html: htmlContent
        }
    });
};


/***/ }),

/***/ 110:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ faq; }
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(97458);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(52983);
// EXTERNAL MODULE: ./modules/Pages/ParkPledgeFAQ/Quill.module.css
var Quill_module = __webpack_require__(45586);
var Quill_module_default = /*#__PURE__*/__webpack_require__.n(Quill_module);
// EXTERNAL MODULE: ../../node_modules/.pnpm/next@13.0.3-canary.1_rlaikcoslzwwtqyk7brpdzej5y/node_modules/next/link.js
var next_link = __webpack_require__(66998);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ../contracts/src/park-safe/create-park-safe-page.dto.ts
var create_park_safe_page_dto = __webpack_require__(45246);
// EXTERNAL MODULE: ../ui/src/components/Wrappers/OutsidePageWrapper.tsx
var OutsidePageWrapper = __webpack_require__(55368);
// EXTERNAL MODULE: ../ui/src/components/Wrappers/InsidePageWrapper.tsx
var InsidePageWrapper = __webpack_require__(70996);
// EXTERNAL MODULE: ../ui/src/components/Typography/Typography.tsx
var Typography = __webpack_require__(59785);
// EXTERNAL MODULE: ../ui/src/components/Button/Button.tsx
var Button = __webpack_require__(57100);
// EXTERNAL MODULE: ../ui/src/components/SimpleImage/index.tsx
var SimpleImage = __webpack_require__(86978);
// EXTERNAL MODULE: ./modules/ParkSafe/hooks.ts + 1 modules
var hooks = __webpack_require__(80452);
// EXTERNAL MODULE: ./utils/useButtonsAnalytics.tsx
var useButtonsAnalytics = __webpack_require__(76356);
// EXTERNAL MODULE: ./utils/routes.ts
var routes = __webpack_require__(22249);
// EXTERNAL MODULE: ./modules/QuillWrapper/QuillWrapper.tsx
var QuillWrapper = __webpack_require__(4245);
;// CONCATENATED MODULE: ./modules/Pages/ParkPledgeFAQ/ParkPledgeFAQ.tsx









const ParkPledgeFAQ = ()=>{
    (0,useButtonsAnalytics/* useButtonsAnalytics */.V)();
    const { useParkSafeQuery  } = (0,hooks/* useParkSafe */.F)();
    const { data: page  } = useParkSafeQuery(create_park_safe_page_dto/* ParkSafePageSlug.FAQ */.tE.FAQ);
    if (!page) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "bg-white",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(OutsidePageWrapper/* OutsidePageWrapper */.d, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(InsidePageWrapper/* InsidePageWrapper */.n, {
                className: "mb-[56px] lg:mt-[70px] lg:gap-10 lg:p-8",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                        className: "w-full flex flex-col-reverse gap-4 md:justify-between md:flex-row",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.Z, {
                                        component: "h1",
                                        variant: "h2",
                                        className: "text-neutral-900 mb-4 md:mb-8",
                                        children: page.title
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                        href: routes/* routes.parkSafePledge */._.parkSafePledge,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.zx, {
                                            tabIndex: -1,
                                            size: "md",
                                            variant: "default",
                                            className: "!py-3.5 mb-8 md:mb-0",
                                            children: "Take the pledge"
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "shrink-0",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SimpleImage/* SimpleImage */.E, {
                                    src: "/media/park-safe.webp",
                                    alt: "park-safe",
                                    width: 260,
                                    height: 208
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(QuillWrapper/* QuillWrapper */._, {
                        htmlContent: page.text,
                        className: (Quill_module_default()).quillContainer
                    })
                ]
            })
        })
    });
};

;// CONCATENATED MODULE: ./pages/park-safe/faq.tsx

var __N_SSP = true;
/* harmony default export */ var faq = (ParkPledgeFAQ);


/***/ }),

/***/ 22249:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "_": function() { return /* binding */ routes; }
/* harmony export */ });
const routes = {
    parkSafePledge: "/park-safe/pledge",
    parkSafeFAQ: "/park-safe/faq",
    homePage: "/"
};


/***/ }),

/***/ 76356:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "V": function() { return /* binding */ useButtonsAnalytics; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52983);
/* harmony import */ var _useAnalytics__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(24900);


const useButtonsAnalytics = ()=>{
    const { onButtonClick  } = (0,_useAnalytics__WEBPACK_IMPORTED_MODULE_1__/* .useAnalytics */ .z)();
    const listenEvent = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)((e)=>{
        if (!e || !e.target) return;
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        //@ts-ignore
        onButtonClick(e.target.textContent);
    }, []);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>{
        if (!document) return;
        const buttons = document.querySelectorAll("button");
        buttons.forEach((button)=>button.addEventListener("click", listenEvent));
        return ()=>{
            buttons.forEach((button)=>button.removeEventListener("click", listenEvent));
        };
    }, []);
};


/***/ }),

/***/ 45246:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "tE": function() { return /* binding */ ParkSafePageSlug; }
/* harmony export */ });
/* unused harmony exports UpsertParkSafePageRequestDTO, ParkSafePageResponseDTO */
/* harmony import */ var _swc_helpers_src_ts_decorate_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(43112);
/* harmony import */ var class_validator__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(92821);
/* harmony import */ var class_validator__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(18418);
/* harmony import */ var class_validator__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(47295);
/* harmony import */ var class_validator__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(58840);



var ParkSafePageSlug;
(function(ParkSafePageSlug) {
    ParkSafePageSlug["PLEDGE"] = "pledge";
    ParkSafePageSlug["FAQ"] = "faq";
})(ParkSafePageSlug || (ParkSafePageSlug = {}));
class UpsertParkSafePageRequestDTO {
}
(0,_swc_helpers_src_ts_decorate_mjs__WEBPACK_IMPORTED_MODULE_0__/* .__decorate */ .gn)([
    (0,class_validator__WEBPACK_IMPORTED_MODULE_1__/* .IsEnum */ .GT)(ParkSafePageSlug),
    (0,_swc_helpers_src_ts_decorate_mjs__WEBPACK_IMPORTED_MODULE_0__/* .__metadata */ .w6)("design:type", String)
], UpsertParkSafePageRequestDTO.prototype, "slug", void 0);
(0,_swc_helpers_src_ts_decorate_mjs__WEBPACK_IMPORTED_MODULE_0__/* .__decorate */ .gn)([
    (0,class_validator__WEBPACK_IMPORTED_MODULE_2__/* .IsString */ .XV)(),
    (0,class_validator__WEBPACK_IMPORTED_MODULE_3__/* .IsNotEmpty */ .rl)(),
    (0,_swc_helpers_src_ts_decorate_mjs__WEBPACK_IMPORTED_MODULE_0__/* .__metadata */ .w6)("design:type", String)
], UpsertParkSafePageRequestDTO.prototype, "text", void 0);
(0,_swc_helpers_src_ts_decorate_mjs__WEBPACK_IMPORTED_MODULE_0__/* .__decorate */ .gn)([
    (0,class_validator__WEBPACK_IMPORTED_MODULE_2__/* .IsString */ .XV)(),
    (0,class_validator__WEBPACK_IMPORTED_MODULE_3__/* .IsNotEmpty */ .rl)(),
    (0,_swc_helpers_src_ts_decorate_mjs__WEBPACK_IMPORTED_MODULE_0__/* .__metadata */ .w6)("design:type", String)
], UpsertParkSafePageRequestDTO.prototype, "title", void 0);
(0,_swc_helpers_src_ts_decorate_mjs__WEBPACK_IMPORTED_MODULE_0__/* .__decorate */ .gn)([
    (0,class_validator__WEBPACK_IMPORTED_MODULE_2__/* .IsString */ .XV)(),
    (0,class_validator__WEBPACK_IMPORTED_MODULE_3__/* .IsNotEmpty */ .rl)(),
    (0,class_validator__WEBPACK_IMPORTED_MODULE_4__/* .IsOptional */ .X)(),
    (0,_swc_helpers_src_ts_decorate_mjs__WEBPACK_IMPORTED_MODULE_0__/* .__metadata */ .w6)("design:type", String)
], UpsertParkSafePageRequestDTO.prototype, "imageKey", void 0);
class ParkSafePageResponseDTO {
}
(0,_swc_helpers_src_ts_decorate_mjs__WEBPACK_IMPORTED_MODULE_0__/* .__decorate */ .gn)([
    (0,class_validator__WEBPACK_IMPORTED_MODULE_1__/* .IsEnum */ .GT)(ParkSafePageSlug),
    (0,_swc_helpers_src_ts_decorate_mjs__WEBPACK_IMPORTED_MODULE_0__/* .__metadata */ .w6)("design:type", String)
], ParkSafePageResponseDTO.prototype, "slug", void 0);
(0,_swc_helpers_src_ts_decorate_mjs__WEBPACK_IMPORTED_MODULE_0__/* .__decorate */ .gn)([
    (0,class_validator__WEBPACK_IMPORTED_MODULE_2__/* .IsString */ .XV)(),
    (0,class_validator__WEBPACK_IMPORTED_MODULE_3__/* .IsNotEmpty */ .rl)(),
    (0,_swc_helpers_src_ts_decorate_mjs__WEBPACK_IMPORTED_MODULE_0__/* .__metadata */ .w6)("design:type", String)
], ParkSafePageResponseDTO.prototype, "title", void 0);
(0,_swc_helpers_src_ts_decorate_mjs__WEBPACK_IMPORTED_MODULE_0__/* .__decorate */ .gn)([
    (0,class_validator__WEBPACK_IMPORTED_MODULE_2__/* .IsString */ .XV)(),
    (0,class_validator__WEBPACK_IMPORTED_MODULE_3__/* .IsNotEmpty */ .rl)(),
    (0,_swc_helpers_src_ts_decorate_mjs__WEBPACK_IMPORTED_MODULE_0__/* .__metadata */ .w6)("design:type", String)
], ParkSafePageResponseDTO.prototype, "text", void 0);
(0,_swc_helpers_src_ts_decorate_mjs__WEBPACK_IMPORTED_MODULE_0__/* .__decorate */ .gn)([
    (0,class_validator__WEBPACK_IMPORTED_MODULE_2__/* .IsString */ .XV)(),
    (0,_swc_helpers_src_ts_decorate_mjs__WEBPACK_IMPORTED_MODULE_0__/* .__metadata */ .w6)("design:type", Object)
], ParkSafePageResponseDTO.prototype, "imageKey", void 0);
(0,_swc_helpers_src_ts_decorate_mjs__WEBPACK_IMPORTED_MODULE_0__/* .__decorate */ .gn)([
    (0,class_validator__WEBPACK_IMPORTED_MODULE_2__/* .IsString */ .XV)(),
    (0,_swc_helpers_src_ts_decorate_mjs__WEBPACK_IMPORTED_MODULE_0__/* .__metadata */ .w6)("design:type", Object)
], ParkSafePageResponseDTO.prototype, "imageUrl", void 0);


/***/ }),

/***/ 70996:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "n": function() { return /* binding */ InsidePageWrapper; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97458);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52983);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(83849);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);



const InsidePageWrapper = (param)=>/*#__PURE__*/ {
    let { children , className , id  } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: classnames__WEBPACK_IMPORTED_MODULE_2___default()("mt-6 w-full max-w-6xl mx-auto", className),
        id: id,
        children: children
    });
};


/***/ }),

/***/ 55368:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "d": function() { return /* binding */ OutsidePageWrapper; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97458);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52983);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(83849);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);



const OutsidePageWrapper = (param)=>/*#__PURE__*/ {
    let { children , className  } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: classnames__WEBPACK_IMPORTED_MODULE_2___default()("p-4 w-full max-w-screen-2xl mx-auto md:p-[30px] lg:p-10", className),
        children: children
    });
};


/***/ }),

/***/ 45586:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"quillContainer":"Quill_quillContainer__K4gQB"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [2931,9774,2888,179], function() { return __webpack_exec__(44772); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);